import {PrimaryButton} from "@fluentui/react";
import * as React from "react";
import {useContext, useEffect, useState} from "react";
import {useParams} from 'react-router-dom';
import AppContent from "../Surfaces/AppContent";
import AuthContext from "../Services/AuthContext";
import ProjectDocumentList from "../Lists/ProjectDocumentList";

function ProjectDocument(props) {
    const [user] = useContext(AuthContext);
    const [documents, setDocuments] = useState([]);
    const [project, setProject] = useState('');
    const [type, setType] = useState('');
    const [number, setNumber] = useState('');
    const [venture, setVenture] = useState('');
    const params = useParams();
    useEffect(() => {
        const abortController = new AbortController();
        async function fetchData() {
            await fetch(`/api/project/document/${params.document}`, {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => {
                    setProject(data[0].project);
                    setType(data[0].type);
                    setNumber(data[0].number);
                    setVenture(data[0].venture);
                    setDocuments(data);
                })
                .catch(err => { console.log(err) })
        }
        fetchData();
        return () => abortController.abort();
    }, [params, user.token]);

    /*const columns = [
        {
            key: 'type',
            name: 'Typ Dokumentu',
            ariaLabel: 'Typ Dokumentu',
            fieldName: 'type',
            minWidth: 160,
            isRowHeader: true,
            isResizable: false,
            onRender: (item) => (<a href={`/api/public/uploaded/${item.filename}`} target={'_blank'}><PrimaryButton text={item.type} /></a>)
        },
        {
            key: 'created',
            name: 'Utworzono',
            ariaLabel: 'Utworzono',
            fieldName: 'created',
            minWidth: 120,
            isResizable: false,
        },
        {
            key: 'user',
            name: 'Użytkownik',
            ariaLabel: 'Użytkownik',
            fieldName: 'user',
            minWidth: 120,
            isResizable: true,
        }
    ];*/


    return (
        <AppContent title={`Historia dokumentu`} backTo={`/project/${params.id}`} subtitle={`${venture}: ${project}`}>
            <ProjectDocumentList data={documents} history={false} title={`${type} ${number}`}/>
        </AppContent>
    );
}
export default ProjectDocument;